<template>
  <div id="Psg">
    <div class="tableItem1 no-border-top">
      <div class="tips">
        <img src="../../assets/jpg/tips.svg" alt="" />
        <span class="china">每日16:00更新昨日数据，所有数据统计从2026/05/14开始</span>
      </div>
      <div
        v-if="loading1"
        v-loading="loading1"
        style="height: 60px"
        class="tableItem1"
      ></div>
      <div v-else>
        <div v-for="(item, index) in totalChannelList" :key="index + 'channel'">
          <div class="title">
            <span class="titleBIg china">{{ formatChannelName(item.totalChannel) }}</span>
            <span class="titleSmall china">截至{{ RefreshTime | dateFormat }}</span>
            <el-row type="flex" class="row-bg" justify="space-around">
              <el-col :span="8"
                ><div class="grid-content bg-purple">
                  <div class="listItem">
                    <p>Total TGT(K)</p>
                    <b>{{ Math.round(item.TARGET_VALUE_Total / 1000) | NumFormat }}</b>
                  </div>
                </div></el-col
              >
              <el-col :span="8"
                ><div class="grid-content bg-purple-light">
                  <div class="listItem" style="text-align: center">
                    <p>YTD Act.(K)</p>
                    <b>{{ (item.SALES_VALUE_YTD / 1000) | NumFormat }}</b>
                  </div>
                </div></el-col
              >
              <el-col :span="8"
                ><div class="grid-content bg-purple">
                  <div class="listItem" style="text-align: right">
                    <p>YTD vs. LY</p>
                    <b>{{ item.YTD_VS_LY | Zheng2 }}%</b>
                  </div>
                </div></el-col
              >
            </el-row>
            <div
              class="EcOne"
              :EcOne="parseInt(Math.round(item.YTD_Achiving * 100)) + '%'"
            >
              <el-progress
                :text-inside="true"
                :stroke-width="20"
                :percentage="parseInt(Math.round((item.YTD_Achiving * 100))) || 0"
                class="Progress1"
                :color="'#019881'"
                :define-back-color="'#B1E0DA'"
              >
              </el-progress>
            </div>
            <!-- <div style="position: relative;margin-top: 5px;">
            <div>YTD Ach.%</div>
            <div v-show="!AliFlag" @click="AliFlag=!AliFlag" class="tableItemImg redPlusActiveImg"></div>
            <div v-show="AliFlag" @click="AliFlag=!AliFlag" class="tableItemImg"></div>
          </div> -->
          </div>
          <div style="border-bottom: 1px solid lightgrey; margin: 50px -20px 25px" v-if="index < totalChannelList.length-1"></div>
        </div>
      </div>
    </div>

    <div class="tableItem2">
      <div class="title" style="padding: 0px 11px 0px; margin: 25px auto">
        <span class="titleBIg china">品牌各渠道达成</span>
        <span class="titleSmall china">截至{{ RefreshTime | dateFormat }}</span>
      </div>
      <tableBrand
        :ChangeFlag="ActiveFlag"
        :TableList1="tableData"
        :AllMyData="AllData"
        v-if="dataShow"
      ></tableBrand>
      <div v-else v-loading="loading" style="height: 60px">
        <tableBrand></tableBrand>
      </div>
    </div>
  </div>
</template>
<script>
import tableBrand from "./tableBrand.vue";
import qs from "qs";
export default {
  data() {
    return {
      ActiveFlag: "tab1",
      tableData: [],
      AllData: null,
      loading: true,
      loading1: false,
      AliFlag: false,
      JDFlag: false,
      RefreshTime: "",
      JDData: [],
      AliData: [],
      AliDCLData: [],
      AliNoDCLData: [],
      JDDCLData: [],
      JDNoDCLData: [],
      dataShow: false,
      totalChannelList: [],
    };
  },
  computed: {},
  methods: {
    formatChannelName(key) {
      let name = "";
      switch (key) {
        case "TOTAL_CHANNEL":
          name = "全渠道销售总览";
          break;
        case "B2C_CHANNEL":
          name = "B2C销售总览(Ali+JD)";
          break;
        case "DY_CHANNEL":
          name = "抖音销售总览";
          break;
      }
      return name;
    },
    getTablist() {
      // this.$addr
      //   .post("/SalesNew/getSalesFGSRealTime")
      //   .then((res) => {
      //     this.tableData = res.data.data;
      //     this.dataShow = true;
      //   })
      //   .catch((error) => {
      //     this.$toast("接受数据失败");
      //   });
      this.$addr
        .post("/SalesNew/getSpikeCoreBrands")
        .then((res) => {
          this.tableData = res.data.data;
          this.dataShow = true;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getTime() {
      this.$addr
        .post("SalesNew/getSalesFGSRealTimeRefreshData")
        .then((res) => {
          var date = new Date();
          var time = "" + date.getFullYear() + (date.getMonth() + 1) + date.getDate();
          if (res.data.data.t0_date) {
            this.RefreshTime = res.data.data.t1_date;
          } else {
            this.RefreshTime = time;
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getTotalChannel() {
      // .post("SalesNew/getSalesFGSRealTimeTotalChannel")
      this.$addr
        .post("SalesNew/getSpikeCoreBrandsTotalChannel")
        .then((res) => {
          this.totalChannelList = res.data.data;
          this.AllData = res.data.data[0] || null;
          this.loading1 = false;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  components: {
    tableBrand,
  },
  created() {
    this.getTotalChannel();
    this.getTablist();
    this.getTime();
  },
};
</script>
<style scoped>
#Psg {
  border-radius: 0 0 20px 20px;
  height: 100%;
  overflow: hidden;
  /* padding: 25px 14px 0;
  border-radius: 0 0 20px 20px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  overflow: hidden; */
}
.tableItemImg {
  position: absolute;
  top: 20%;
  bottom: 0;
  margin: auto;
  right: 0;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top-color: #001ba7;
}
.redPlusActiveImg {
  -webkit-transform: rotate(-180deg) !important;
  transform: rotate(-180deg) !important;
  top: -50%;
}
.tips {
  background: #ededed;
  border-radius: 5px;
  text-align: center;
  padding: 2px;
  margin-bottom: 25px;
}
.tips span {
  font-family: "Heiti SC";
  font-style: normal;
  font-weight: normal;
  font-size: 9px;
  line-height: 20px;
  color: #000;
}
.title {
  color: #000;
  margin-bottom: 20px;
}
.title .titleBIg {
  font-size: 22px;
  margin-right: 15px;
}
.title .titleSmall {
  font-size: 12px;
}
.listItem {
  margin: 25px auto;
}
.listItem p {
  font-size: 10px !important;
  line-height: 12px;
  font-weight: bold;
  margin-bottom: 6px;
}
.listItem b {
  font-size: 20px;
}
.Progress {
  margin: 20px auto 36px;
}
.Progress1 {
  position: relative;
}
.bgColor {
  opacity: 0.6;
}
/* .Progress1::before {
  position: absolute;
  content: "YTD Ach.%";
  color: #000;
  font-weight: bold;
  font-size: 10px;
  line-height: 25px;
  z-index: 9999;
  top: 25px;
  left: 0;
} */

/* .Progress1::after {
  text-align: center;
  content: "100%";
  font-size: 10px;
  background: #f46a6e;
  color: #fff;
  border-radius: 20px;
  line-height: 38px;
  display: block;
  width: 38px;
  height: 38px;
  position: absolute;
  top: -6px;
  right: 29%;
  transform: scale(0.6);
  box-shadow: 0px 0px 5px 0 rgba(0, 0, 0, 0.35);
} */
.Progress2 {
  position: relative;
}
.Progress2::before {
  position: absolute;
  content: "LD Contri.%";
  color: #000;
  font-weight: bold;
  font-size: 10px;
  line-height: 25px;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 10px;
  right: 0;
  margin: auto;
}
/* .Progress2::after {
  content: "1%";
  font-size: 10px;
  text-align: center;
  background: #f46a6e;
  color: #fff;
  border-radius: 20px;
  line-height: 38px;
  display: block;
  width: 38px;
  height: 38px;
  position: absolute;
  top: -6px;
  right: 48%;
  transform: scale(0.6);
  box-shadow: 0px 0px 5px 0 rgba(0, 0, 0, 0.35);
} */
.Progress3 {
  position: relative;
}
/deep/ .el-progress-bar__outer {
  border-radius: 9px 20px 20px 9px !important;
  position: relative;
  background: rgba(207, 64, 68, 0.1);
}
.tableItem1 {
  margin: 0 auto 12px;
  padding: 25px 25px 45px;
  border-radius: 0 20px 20px 20px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
.tableItem2 {
  margin: 10px auto 0px;
  padding: 1px 14px 0;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
.EcOne,
.EcTwo {
  position: relative;
}
.EcOne::after,
.EcTwo::after,
.EcThree::after,
.EcFour::after,
.EcFive::after,
.EcSix::after {
  font-weight: bold;
  font-size: 11px;
  color: #fff;
  position: absolute;
  line-height: 25px;
  left: 2%;
  top: 0;
}
.EcOneElse::after {
  /* font-weight: bold; */
  font-size: 11px;
  color: #000;
  position: absolute;
  line-height: 16px;
  left: 2%;
  top: 0;
}
.EcOne::after {
  content: attr(EcOne);
}
.EcTwo::after {
  content: attr(EcTwo);
}
/deep/ .el-progress-bar__inner {
  border-radius: 9px 20px 20px 9px !important;
  background: #001ba7;
  top: 3px;
  bottom: 4px;
  height: unset;
}
/deep/ .el-progress-bar__innerText {
  display: none !important;
}
.china {
  font-family: "微软雅黑" !important;
}
.listItem1 {
  margin: 5px auto;
}
.no-border-top {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WarRoom/Psg.vue